// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Field } from 'redux-form';
import WorkTypesField from '../../customFields/WorkTypesField';

const WorkTypesSection = ({ requirements }) => (
  <div>
    <Field
      name="workTypes"
      component={WorkTypesField}
      label="Work Type"
      required={requirements !== 'disabled'}
      toolsElementClass="chip"
      deleteElementIconColor="#41566a"
    />
  </div>
);

export default WorkTypesSection;
